import { useDetailsBidOnAgent } from './events/details/useDetailsBidOnAgent'
import { useDetailsItemCarInPrepare } from './events/details/useDetailsItemCarInPrepare'
import { useDetailsItemPublish } from './events/details/useDetailsItemPublish'
import { useDetailsItemWithdrawOrDelete } from './events/details/useDetailsItemWithdrawOrDelete'
import { useDetailsUserBid } from './events/details/useDetailsUserBid'

export const DETAILS_SOCKET_CALLBACK = 'details-update'

export function useDetailsSocket() {
  const { userBid } = useDetailsUserBid()
  const { itemPublish } = useDetailsItemPublish()
  const { itemWithdrawOrDelete } = useDetailsItemWithdrawOrDelete()
  const { carInPrepare } = useDetailsItemCarInPrepare()
  const { bidOnAgent } = useDetailsBidOnAgent()

  const init = () => {
    userBid()
    itemPublish()
    itemWithdrawOrDelete()
    carInPrepare()
    bidOnAgent()
  }

  return { init }
}
